import(/* webpackMode: "eager" */ "/tmp/8df2af0f45d266b/src/app/template.tsx");
